import { useMutation, useQueryClient } from "@tanstack/react-query"
import { respondToOffer } from "@/api"

export const useRespondToOffer = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ dealId, offerNumber, isAccepted, declineMessage }: { dealId: number, offerNumber: number, isAccepted: boolean, declineMessage?: string }) =>
      respondToOffer({ dealId, offerNumber, isAccepted, declineMessage }),

    onSuccess: (data, variables) => {
      queryClient.invalidateQueries({ queryKey: ["clientDeals"] });
    },
  })
}